// let bulletData: {[index: string]:any};
import * as bulletData from "./bulletData.json";
import { Maps } from "./maps"; // typescript was being dumb and wouldnt recognize "Maps" without the direct reference
// import { Math } from "phaser";

// https://www.phaser.io/examples/v3/view/games/topdownshooter/topdowncombatmechanics
export class Bullet extends Phaser.Physics.Arcade.Sprite {
	bulletType: string;
	born: number;
	direction: number;
	constructor(scene: Phaser.Scene, x: number, y: number) {
		const json: { [index: string]: BulletJSON } = bulletData;
		super(scene, x, y, "sprites", "bullet6.png");
		this.bulletType = "bullet";
		this.born = 0;
		this.direction = 0;
	}

	create(
		type: string,
		scene: Phaser.Scene,
		player: Phaser.Physics.Arcade.Sprite,
		target: { x: number; y: number }
	): void {
		const json: { [index: string]: BulletJSON } = bulletData;
		this.bulletType = type;
		this.setTexture("sprites", json[this.bulletType].sprite);
		this.setSize(
			12 * json[this.bulletType].sizeMultipler,
			12 * json[this.bulletType].sizeMultipler
		);
		this.setPosition(player.x, player.y); // Initial position
		// this.direction = Math.atan((target.x - this.x) / (target.y - this.y));
		// some light randomness to the bullet angle
		if (json[this.bulletType].randomness > 0) {
			// this.direction +=
			// Math.random() / json[this.bulletType].randomness +
			// -(Math.random() / json[this.bulletType].randomness);
		}

		this.setOrigin(0.5, 0.5);
		// angle bullet with shooters rotation
		this.setDamping(true);
		this.setDrag(json[this.bulletType].drag);
		const rotation: number =
			Phaser.Math.Angle.Between(player.x, player.y, target.x, target.y) +
			(Phaser.Math.Between(
				-json[this.bulletType].randomness / 2,
				json[this.bulletType].randomness / 2
			) *
				Math.PI) /
				180;
		if (json[this.bulletType].rotate) {
			this.rotation = rotation;
			scene.physics.velocityFromRotation(
				this.rotation,
				json[this.bulletType].velocity,
				this.body.velocity
			);
		} else {
			this.rotation = 0;
			scene.physics.velocityFromRotation(
				rotation,
				json[this.bulletType].velocity,
				this.body.velocity
			);
		}
		this.born = 0;
	}

	update(time: number, delta: number): void {
		const json: { [index: string]: BulletJSON } = bulletData;
		this.born += delta;
		if (this.born > json[this.bulletType].lifetime) {
			this.setActive(false).setVisible(false);
			this.x = -100;
			this.y = -100;
			this.setVelocity(0, 0);
		}
	}
}
